import React from 'react';

import { EVENTS_IMAGE_URLS } from './constants';

const EventsSection = () => (
  <section className="relative -mx-16 mt-48 overflow-hidden sm:-mx-28 sm:mt-112">
    {/* Three photo placeholders side-by-side */}
    <div
      className="flex h-[calc(200vw*(337/575))] flex-col sm:h-[337px] sm:flex-row"
      aria-hidden="true"
    >
      {EVENTS_IMAGE_URLS.map((imageUrl) => (
        <img
          key={imageUrl}
          className="block h-auto w-full object-cover last-of-type:hidden sm:h-full sm:w-1/3 sm:last-of-type:block"
          src={imageUrl}
          role="presentation"
          loading="lazy"
        />
      ))}
    </div>

    {/* Dark gradient overlay */}
    <div
      className="absolute inset-0"
      style={{
        background:
          'linear-gradient(270deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 35%, rgba(0,0,0,0.7) 65%, rgba(0,0,0,0) 100%)',
      }}
      aria-hidden="true"
    />

    {/* Text overlay — centered */}
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-16 px-16 text-center sm:px-28">
      <h2 className="m-0 font-suisse-works text-headline-sm text-white sm:text-headline-lg">
        The Information Events
      </h2>
      <div className="max-w-[700px] font-suisse-neue text-body-lg text-white">
        <p className="m-0 mb-16 text-pretty">
          The Information’s events—virtual and live—deliver insider perspectives you can’t get
          elsewhere. Subscribers get free or discounted access.
        </p>
        <p className="m-0 font-suisse-intl text-description-lg font-medium">
          Financing the AI Revolution | Women in Tech, Media and Finance | Webinars
        </p>
      </div>
    </div>
  </section>
);

export default EventsSection;
